import React from 'react';
import {
  Button, Col, Modal, Row, Spinner,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ImAttachment } from 'react-icons/im';

type SyncSolicitudDocNeverSyncedModalProps = {
  show: boolean;
  accountId: number | null;
  isStarting: boolean;
  onClose: () => void;
  onStartSync: () => void;
};

function SyncSolicitudDocNeverSyncedModal( {
  show,
  accountId,
  isStarting,
  onClose,
  onStartSync,
}: SyncSolicitudDocNeverSyncedModalProps ) {
  const { t } = useTranslation();

  return (
    <Modal show={show} centered onHide={onClose}>
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4 d-flex align-items-center justify-content-center gap-2">
              <ImAttachment className="text-primary" />
              {t( 'admin.account.syncSolicitudDocNeverSyncedTitle' )}
            </h3>
            <p className="text--sm text-center text-muted mb-2">
              {t( 'admin.account.syncSolicitudDocNeverSyncedSubtitle' )}
            </p>
            <p className="text--sm text-center mb-4">
              {t( 'admin.account.syncSolicitudDocNeverSyncedAccount', { accountId: accountId ?? '-' } )}
            </p>
            <Row>
              <Col className="m-auto mt-2">
                <Button
                  variant="outline-primary"
                  className="btn--full-width"
                  type="button"
                  disabled={isStarting}
                  onClick={onClose}
                >
                  {t( 'close' )}
                </Button>
              </Col>
              <Col className="m-auto mt-2">
                <Button
                  variant="primary"
                  className="btn--full-width d-flex align-items-center justify-content-center gap-2"
                  type="button"
                  disabled={isStarting}
                  onClick={onStartSync}
                >
                  {isStarting && <Spinner animation="border" size="sm" />}
                  {t( 'admin.account.syncSolicitudDocSyncButton' )}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default SyncSolicitudDocNeverSyncedModal;
